<template>
  <v-snackbar
    bottom
    v-model="snackbar.visible"
    :timeout="snackbar.timeout"
    :multi-line="snackbar.multiline === true"
    :color="snackbar.color"
  >
    {{ snackbar.text }}
  </v-snackbar>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  computed: {
    snackbar() {
      return this.$store.state.snackbar;
    },
  },
  methods: {
    ...mapMutations(["closeSnackbar"]),
  },
};
</script>
